import PropTypes from 'prop-types';
import { SET_APP_DATA } from './App.actions';
import { mapValues } from 'lodash';

export const propTypes = {
    assets: PropTypes.object,
};

export const defaultProps = {
	assets: null,
};

export const mapStateToProps = {
    app: ( state, action ) => {
        switch ( action.type ) {
            case SET_APP_DATA:
                return {
                    ...state,
                    assets: {
                        ...action.assets,
                        // This function sorts the terms into their hierarchical form.
                        terms: mapValues( action.assets.terms, terms => {
                            let map = {};
                            // Create the map
                            terms.forEach( term => {
                                map[ term.term_id ] = {
                                    ...term,
                                    children: []
                                };
                            });
                            // Put children with their parent object
                            terms.forEach( term => {
                                if ( term.parent ) {
                                    map[ term.parent ].children.push( map[ term.term_id ] );
                                }
                            });
                            // Return just the values, filtering out ones that have a parent ( those appear lower in the hierarchy )
                            return Object.values( map ).filter( term => {
                                return ! term.parent;
                            });
                        })
                    },
                };
            default:
                return state;
        }
    }
};

export const mapDispatchToProps = {};



// WEBPACK FOOTER //
// ./src/containers/App/App.props.js